export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/noop.js
// module id = ./node_modules/d3-shape/src/noop.js
// module chunks = vendor